module.exports = __webpack_public_path__ + "static/media/datascience.7626d032.jpg";